/* eslint-disable prettier/prettier */
import avax2 from 'assets/svg/coins1/avax.svg'
import bnb2 from 'assets/svg/coins1/bnb.svg'
import btc2 from 'assets/svg/coins1/btc.svg'
import dai2 from 'assets/svg/coins1/dai.svg'
import eth2 from 'assets/svg/coins1/eth.svg'
import link2 from 'assets/svg/coins1/link.svg'
import litecoin2 from 'assets/svg/coins1/ltc.svg'
import solana2 from 'assets/svg/coins1/sol.svg'
import trx2 from 'assets/svg/coins1/trx.svg'
import usdp2 from 'assets/svg/coins1/usdp.svg'
import wbtc2 from 'assets/svg/coins1/wbtc.svg'
import air_drop from 'assets/svg/coins2/airdrop-usdt.svg'
import arb2 from 'assets/svg/coins2/arb.svg'
import avax1 from 'assets/svg/coins2/avax.svg'
import busd2 from 'assets/svg/coins2/b_busd.svg'
import bch2 from 'assets/svg/coins2/bch.svg'
import bnb1 from 'assets/svg/coins2/bnb.svg'
import btc1 from 'assets/svg/coins2/btc.svg'
import dai1 from 'assets/svg/coins2/dai.svg'
import eth1 from 'assets/svg/coins2/eth.svg'
import link1 from 'assets/svg/coins2/link.svg'
import litecoin1 from 'assets/svg/coins2/ltc.svg'
import matic2 from 'assets/svg/coins2/matic.svg'
import solana1 from 'assets/svg/coins2/sol.svg'
import stETH2 from 'assets/svg/coins2/stETH.svg'
import stmatic2 from 'assets/svg/coins2/stmatic.svg'
import ton2 from 'assets/svg/coins2/ton.svg'
import trx1 from 'assets/svg/coins2/tron.svg'
import tusd2 from 'assets/svg/coins2/tusd.svg'
import usdc2 from 'assets/svg/coins2/usdc.svg'
import usdd2 from 'assets/svg/coins2/usdd.svg'
import usdp1 from 'assets/svg/coins2/usdp.svg'
import usdt2 from 'assets/svg/coins2/usdt.svg'
import wbtc1 from 'assets/svg/coins2/wbtc.svg'
import xrp2 from 'assets/svg/coins2/xrp.svg'
import { CURRENCIES } from '../../../constants/currenciesIcons'

import POLUSD from 'assets/svg/Sticky/POLUSD'

export const coinIcons: Record<string, string[]> = {
  [CURRENCIES.BTC]: [btc1, btc2],
  [CURRENCIES.DAI]: [dai1, dai2],
  [CURRENCIES.PAX]: [usdp1, usdp2],
  [CURRENCIES.WBTC]: [wbtc1, wbtc2],
  [CURRENCIES.LINK]: [link1, link2],
  [CURRENCIES.TRX]: [trx1, trx2],
  [CURRENCIES.ALL_ETH]: [eth1, eth2],
  [CURRENCIES.ALL_BUSD]: [busd2, busd2],
  [CURRENCIES.ALL_USDT]: [usdt2, usdt2],
  [CURRENCIES.ALL_USDC]: [usdc2, usdc2],
  [CURRENCIES.ALL_MATIC]: [matic2, matic2],
  [CURRENCIES.ALL_TUSD]: [tusd2, tusd2],
  [CURRENCIES.TON]: [ton2, ton2],
  [CURRENCIES.STETH]: [stETH2, stETH2],
  [CURRENCIES.STMATIC]: [stmatic2, stmatic2],
  [CURRENCIES.T_USDD]: [usdd2, usdd2],
  [CURRENCIES.ARB_ARB]: [arb2, arb2],
  [CURRENCIES.XRP]: [xrp2, xrp2],
  [CURRENCIES.BCH]: [bch2, bch2],
  [CURRENCIES.AVAX]: [avax1, avax2],
  [CURRENCIES.SOL]: [solana1, solana2],
  [CURRENCIES.BNB]: [bnb1, bnb2],
  [CURRENCIES.LTC]: [litecoin1, litecoin2],
  AIR_USDT: [air_drop, air_drop],

  [CURRENCIES.ALL_POL]: [POLUSD, POLUSD],
  [CURRENCIES.STPOL]: [POLUSD, POLUSD],
}
